import { type FC, type ReactNode } from "react";
import Rollbar from "rollbar/replay";
import { Provider } from "@rollbar/react";

import { REACT_APP_ROLLBAR_ACCESS_TOKEN, ENABLE_ROLLBAR, DS_ENV } from "@ds/constants/environment";

const rollbarConfig: Rollbar.Configuration = {
  enabled: ENABLE_ROLLBAR,
  accessToken: REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: DS_ENV,
  // use "testenv" for testing without polluting other environments
  // environment: "testenv",
  captureUncaught: true,
  captureUnhandledRejections: true,
  replay: {
    enabled: true,
  },
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
};

export const rollbar = new Rollbar(rollbarConfig);

export const setRollbarUser = (user: AuthUser) =>
  rollbar.configure({
    payload: {
      person: {
        id: String(user.id),
        email: user.email,
        username: `${user.given_name} ${user.family_name}`,
      },
    },
  });

export const clearRollbarUser = () => rollbar.configure({ payload: { person: undefined } });

export const RollbarProvider: FC<{ children: ReactNode }> = ({ children }) =>
  ENABLE_ROLLBAR ? <Provider instance={rollbar}>{children}</Provider> : <>{children}</>;
